
import React, {
    useEffect,
    useState
} from "react";

import {
    Link,
    useParams
} from "react-router-dom";

import {
    FaArrowLeft,
    FaUser,
    FaCalendarAlt,
    FaBookOpen
} from "react-icons/fa";

import API_BASE_URL from "../config/config";

import "./BlogDetail.css";


const BlogDetail = () => {

    const {
        id
    } = useParams();

    const API_URL =
        API_BASE_URL.replace(/\/$/, "");

    const STORAGE_BASE_URL =
        API_URL.replace(/\/api$/, "");

    const IMAGE_STORAGE_URL =
        `${STORAGE_BASE_URL}/storage/blog`;


    const [blog, setBlog] = useState(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | IMAGE URL
    |--------------------------------------------------------------------------
    */

    const getImageUrl = (image) => {

        if (!image) {
            return "";
        }

        if (
            image.startsWith("http://") ||
            image.startsWith("https://")
        ) {
            return image;
        }

        return `${IMAGE_STORAGE_URL}/${image.replace(
            /^\/+/,
            ""
        )}`;
    };


    /*
    |--------------------------------------------------------------------------
    | DATE FORMAT
    |--------------------------------------------------------------------------
    */

    const formatDate = (date) => {

        if (!date) {
            return "";
        }

        const dateObject =
            new Date(date);

        if (
            Number.isNaN(
                dateObject.getTime()
            )
        ) {
            return date;
        }

        return dateObject.toLocaleDateString(
            "en-US",
            {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        );
    };


    /*
    |--------------------------------------------------------------------------
    | FETCH BLOG
    |--------------------------------------------------------------------------
    */

    const fetchBlog = async () => {

        try {

            setLoading(true);

            setError("");

            const response =
                await fetch(
                    `${API_URL}/user-blogs/${id}`
                );

            const data =
                await response.json();

            console.log(
                "BLOG DETAIL:",
                data
            );


            if (
                response.ok &&
                data.success
            ) {

                setBlog(data.data);

            } else {

                setBlog(null);

                setError(
                    data.message ||
                    "Blog not found."
                );
            }

        } catch (error) {

            console.error(
                "BLOG DETAIL ERROR:",
                error
            );

            setBlog(null);

            setError(
                "Unable to load blog."
            );

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | LOAD BLOG
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (id) {
            fetchBlog();
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

    }, [id]);


    /*
    |--------------------------------------------------------------------------
    | LOADING
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (
            <section className="blog-detail-section">

                <div className="container">

                    <div className="blog-detail-loading">

                        <div
                            className="spinner-border"
                            role="status"
                        />

                        <p>
                            Loading blog...
                        </p>

                    </div>

                </div>

            </section>
        );
    }


    /*
    |--------------------------------------------------------------------------
    | ERROR
    |--------------------------------------------------------------------------
    */

    if (error || !blog) {

        return (
            <section className="blog-detail-section">

                <div className="container">

                    <div className="blog-detail-error">

                        <FaBookOpen />

                        <h3>
                            Blog Not Found
                        </h3>

                        <p>
                            {error ||
                                "The requested blog could not be found."}
                        </p>

                        <Link
                            to="/"
                            className="blog-detail-back"
                        >
                            <FaArrowLeft />
                            Back to Home
                        </Link>

                    </div>

                </div>

            </section>
        );
    }


    /*
    |--------------------------------------------------------------------------
    | BLOG DETAIL
    |--------------------------------------------------------------------------
    */

    return (

        <section className="blog-detail-section">

            <div className="container">

                {/* Back Button */}

                <div className="blog-detail-top">

                    <Link
                        to="/"
                        className="blog-detail-back"
                    >
                        <FaArrowLeft />
                        Back to Blogs
                    </Link>

                </div>


                {/* Blog Article */}

                <article className="blog-detail-card">


                    {/* Image */}

                    {blog.image && (

                        <div className="blog-detail-image">

                            <img
                                src={getImageUrl(
                                    blog.image
                                )}
                                alt={blog.title}
                            />

                        </div>

                    )}


                    {/* Content */}

                    <div className="blog-detail-content">


                        {/* Meta */}

                        <div className="blog-detail-meta">

                            <span>

                                <FaUser />

                                {blog.author}

                            </span>


                            <span>

                                <FaCalendarAlt />

                                {formatDate(
                                    blog.date_added
                                )}

                            </span>

                        </div>


                        {/* Title */}

                        <h1>
                            {blog.title}
                        </h1>


                        {/* Decoration */}

                        <div className="blog-detail-line">
                        </div>


                        {/* Full Description */}

                        <div
                            className="blog-detail-description"
                            dangerouslySetInnerHTML={{
                                __html:
                                    blog.description
                            }}
                        />


                    </div>

                </article>


                {/* Bottom Back Button */}

                <div className="blog-detail-bottom">

                    <Link
                        to="/"
                        className="blog-detail-back"
                    >
                        <FaArrowLeft />
                        Back to Blogs
                    </Link>

                </div>

            </div>

        </section>

    );
};


export default BlogDetail;
